import { useDispatch } from "react-redux";
import type { AppDispatch } from "@/core/store.ts";

const useAppDispatch = useDispatch.withTypes<AppDispatch>();

export default useAppDispatch;
